import CityPageTemplate from "../city-template/CityPageTemplate";
import { oldTownConfig } from "./data";

export default function OldTownPage() {
  return <CityPageTemplate config={oldTownConfig} />;
}